import { useAutocorrectStore } from '@/modules/control/stores/autocorrect.store.ts';
import { useFileEditorStore } from '@/modules/document/stores/file-editor.ts';
import { usePreviewFilesStore } from '@/modules/document/stores/preview-files.ts';
import { useDocumentRowStore } from '@/modules/document/stores/document-row.store.ts';
import { useCounterpartyRowStore } from '@/modules/counterparty/stores/counterparty-row.store.ts';
import { useDocGanttStore } from '@/modules/document/stores/doc-gantt.store.ts';
import { useDocViewsStore } from '@/modules/document/stores/doc-views.store.ts';
import { useDocLinksStore } from '@/modules/document/stores/doc-links.store.ts';
import { useDocClientsStore } from '@/modules/document/stores/doc-clients.store.ts';
import { useDocSignaturesStore } from '@/modules/document/stores/doc-signatures.store.ts';
import { useDocAccessStore } from '@/modules/document/stores/doc-access.store.ts';
import { useDocAuditStore } from '@/modules/document/stores/doc-audit.store.ts';
import { useDocCommentsStore } from '@/modules/document/stores/doc-comments.store.ts';
import { useDocumentListStore } from '@/modules/document/stores/document-list.store.ts';
import { useCounterpartyAddressesStore } from '@/modules/counterparty/stores/counterparty-addresses.store.ts';
import { useCounterpartyCommentsStore } from '@/modules/counterparty/stores/counterparty-comments.store.ts';
import { useCounterpartyContactsStore } from '@/modules/counterparty/stores/counterparty-contacts.store.ts';
import { useCounterpartyDocsStore } from '@/modules/counterparty/stores/counterparty-docs.store.ts';
import { useCounterpartyListStore } from '@/modules/counterparty/stores/counterparty-list.store.ts';
import { useBankDetailsStore } from '@/modules/counterparty/stores/bank-details.store.ts';
import { useUserListStore } from '@/modules/core/stores/user-list.store.ts';
import { useSignStore } from '@/modules/core/stores/sign.store.ts';
import { resetDocumentMaster } from '@/modules/document/document-master/document-master.ts';
import { resetCounterpartyMaster } from '@/modules/counterparty/counterparty-master/counterparty-master.ts';

export function resetFeatureState() {
  [
    useAutocorrectStore(),
    useFileEditorStore(),
    usePreviewFilesStore(),
    useDocumentRowStore(),
    useCounterpartyRowStore(),
  ].forEach((store) => store.$reset());
  [
    useDocGanttStore(),
    useDocViewsStore(),
    useDocLinksStore(),
    useDocClientsStore(),
    useDocSignaturesStore(),
    useDocAccessStore(),
    useDocAuditStore(),
    useDocCommentsStore(),
    useDocumentListStore(),
    useCounterpartyAddressesStore(),
    useCounterpartyCommentsStore(),
    useCounterpartyContactsStore(),
    useCounterpartyDocsStore(),
    useCounterpartyListStore(),
    useBankDetailsStore(),
    useUserListStore(),
    useSignStore(),
  ].forEach((store) => store.clear());
  resetDocumentMaster();
  resetCounterpartyMaster();
}
